// extracted by mini-css-extract-plugin
export default {"button":"styles_button__X44d5","disabled":"styles_disabled__xYGUb"};